import React from 'react'
import { useNavigate } from 'react-router-dom'
import { mutate } from 'swr'

import { Footer } from '@frame/ui-components/footer'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

import { InfoAlert } from '@frame/images/icons/info-alert'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { useStore } from '@frame/lib/stores/useStore'
import { getTextForVerificationType, getVerifierDisplayName } from '@frame/lib/utils/session'
import { routes, sessionStateRoutes } from '@frame/routes'
import { DataAttribute } from '@frame/types'

export function ConnectionError() {
  const navigate = useNavigate()
  const task = useDirectTask()
  const { verifierName, verificationType, isMultiEmployer, verifierType, tenantPropertyName } = useStore(
    ({ session }) => ({
      verifierName: session?.originating_party_display_name,
      verificationType: session?.verification_type,
      isMultiEmployer: Boolean(session?.max_employments && session.max_employments > 1),
      tenantPropertyName: session?.configuration?.cobranding?.tenant_property?.property_name,
      verifierType: session?.verifier_type,
    })
  )
  const employerName = task?.employer_name || 'this employer'
  const incomeOrEmployment = getTextForVerificationType(verificationType)
  const displayName = getVerifierDisplayName(verifierType, verifierName, tenantPropertyName)

  function handleClick() {
    if (isMultiEmployer) {
      mutate(['all', 'tasks'])
      navigate(routes.root, { state: { task } })
    } else {
      navigate(sessionStateRoutes['terminal-failed'], { replace: true })
    }
  }

  return (
    <>
      <Body
        data-cy={DataAttribute.SCREEN_CONNECTION_ERROR}
        className="flex flex-col items-center p-5"
        paddingTopOverride={36}
      >
        <InfoAlert className="my-2" />
        <div className="space-y-5">
          <H2>We're experiencing an issue</H2>
          <P>An unexpected error occurred and we couldn't verify {employerName}.</P>
          <P>
            Once you submit your {incomeOrEmployment} history, {displayName} will take it from there.
          </P>
        </div>
      </Body>
      <Footer buttons={{ primary: <Button onClick={handleClick}>Ok</Button> }} />
    </>
  )
}
